import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-xl text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        secondary:
          "border border-customDarkBlue text-customDarkBlue border-input bg-background hover:bg-customDarkBlue hover:text-white border-rounded bg-white border-customDarkBlue",
        rejected:
          "border border-customRed text-customRed border-input bg-background hover:bg-customRed hover:text-white border-rounded bg-white border-customRed",
        cancel:
          "border border-customOrange text-customOrange border-input bg-background hover:bg-customOrange hover:text-white border-rounded bg-white border-customOrange",
        default:
          "bg-customDarkBlue text-primary-foreground shadow hover:bg-customDarkBlue/80",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        primary:
          "bg-customOrange text-primary-foreground shadow hover:bg-customOrange/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    (<Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />)
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
